import { ContactsBirthdateWUT } from '@wix/form-fields/wut';

export default ContactsBirthdateWUT;
